import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';
import {
  getForm, getSchema, handleFindEmailByEID, handleReaasignEID,
} from './helper';
import NormalInput from '../../inputs/normalInput';
import NormalButton from '../../buttons/normalButton';
import { isValidEmail } from '../../../../utils/index';
import { toastrSuccess } from '../../../../utils/toastNotification';

import './style.scss';


const ReassignEIDModal = (props) => {
  const [state, setState] = useState({
    loading: false,
    findingEmail: false,
  });
  const suffixIcon = state.findingEmail ? <LoadingOutlined /> : <span />;

  const schema = getSchema();
  const form = getForm(schema);

  const onCancel = () => {
    props.onCancel();
  };

  const onReassign = (data) => {
    props.onReassign(data);
    onCancel();
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    form.clearErrors('newAccount');
    // check isValid Email
    if (!isValidEmail(form.getValues('newAccount'))) {
      form.setError('newAccount', { message: 'Email format is incorrect.' });
      return;
    }
    if (form.getValues('eID').length !== 32) {
      form.setError('eID', { message: "eID is invalid or hasn't been assigned to any account yet." });
      return;
    }
    if (form.getValues('newAccount') === form.getValues('currentAccount')) {
      form.setError('newAccount', { message: 'The new account cannot be the same as the current one.' });
      return;
    }
    const reassignEID = await handleReaasignEID(form.getValues('eID'), form.getValues('newAccount'));
    if (!reassignEID.isSuccess) {
      form.setError('newAccount', { message: reassignEID?.message.includes('record') ? 'This account is not available. Please try again.' : reassignEID.message });
      return;
    }
    onReassign(form.getValues());
    toastrSuccess('eID ressigned successfully');
  };

  const findEmail = async () => {
    if (form.getValues('eID').length === 0) {
      return;
    }
    setState({ findingEmail: true });
    try {
      const email = await handleFindEmailByEID(form.getValues('eID'));
      if (email) {
        form.setValue('currentAccount', email);
      } else {
        form.setError('eID', { message: "eID is invalid or hasn't been assigned to any account yet." });
      }
    } catch (error) {
      form.setError('newAccount', { message: error });
    }
    setState({ findingEmail: false });
  };

  useEffect(() => {
    form.reset();
  }, [props.visible]);


  return (
    <Modal
      title="Reassign eID to new account"
      className="reassign-eid-modal"
      visible={props.visible}
      onCancel={onCancel}
      maskClosable={props.maskClosable}
      footer={[
        <NormalButton
          className="reassign-btn"
          key="submit"
          type="primary"
          text="Reassign eID"
          disabled={!form?.formState?.isValid}
          loading={state.loading}
          onClick={onSubmit}
        />,
      ]}
    >
      <form onSubmit={onSubmit}>
        <NormalInput
          name="eID"
          title="eID"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="eID"
          onBlur={findEmail}
          isNumeric
          maxLength={32}
          errMsg={form?.formState?.errors?.eID?.message}
        />
        <NormalInput
          className="mt-10"
          name="currentAccount"
          placeholder="Currently assigned account"
          isUseForm
          control={form?.control}
          title="Currently assigned account"
          disabled
          suffix={suffixIcon}
        />
        <NormalInput
          className="mt-10"
          name="newAccount"
          title="New assigned account"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="New assigned account"
          errMsg={form?.formState?.errors?.newAccount?.message}
        />
      </form>
    </Modal>
  );
};

ReassignEIDModal.defaultProps = {
  visible: false,
  maskClosable: false,

  onCancel: () => {},
  onReassign: () => {},
};

ReassignEIDModal.propTypes = {
  visible: PropTypes.bool,
  maskClosable: PropTypes.bool,

  onCancel: PropTypes.func,
  onReassign: PropTypes.func,
};

export default ReassignEIDModal;
